import { v4 } from "uuid";
import { FormatMsg } from "src/hooks/useFormatMsg";

export const getUniqueInputId = (): string => `contained-button-file${v4()}`;

export const getTooltipString = (
  disabled: boolean,
  formatMsg: FormatMsg
): string =>
  disabled
    ? formatMsg("segments.file_input.tooltip.disable_reason")
    : formatMsg("segments.file_input.tooltip.upload_file");
